export default __webpack_public_path__ + "static/media/B_lopetus1.5d3ae51f.mp3";